import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles';

const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background-color: ${colors.custom.lightestGray50};
  border-bottom: 1px solid ${colors.gray.light};
  box-sizing: border-box;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

export default {
  header,
};
